import React from "react";
class ReviewComment extends React.Component {
  state = {
    ref: this.props.reviewId + "comment",
    commentText: "",
  };

  componentDidMount() {
    this.refs[this.state.ref].focus();
  }

  submitComment = e => {
    e.preventDefault();

    if (this.state.commentText.trim()) {
      this.props.submitComment(this.props.reviewId, this.state.commentText);
      this.setState({ commentText: "" });
    }
  };

  updateComment = e => {
    this.setState({ commentText: e.target.value });
  };

  render() {
    return (
      <form className="comment_form" onSubmit={this.submitComment}>
        <textarea
          onChange={this.updateComment}
          placeholder="Write a comment..."
          ref={this.state.ref}
          value={this.state.commentText}></textarea>
        <button className="standalone-link" type="submit">
          Submit
        </button>
      </form>
    );
  }
}

export default ReviewComment;
